import React from "react";
import { Typography, TypographyProps } from "@material-ui/core";

/* eslint-disable react/jsx-props-no-spreading */
type CustomTypographyProps = TypographyProps<
    React.ElementType,
    { children: JSX.Element | JSX.Element[] | Text | string }
>;

// Headings
export const H1 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="h1">{children}</Typography>;

export const H2 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="h2">{children}</Typography>;

export const H3 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="h3">{children}</Typography>;

export const H4 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="h4">{children}</Typography>;

export const H5 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="h5">{children}</Typography>;

export const H6 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="h6">{children}</Typography>;

// Body

export const Subtitle = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="subtitle1">{children}</Typography>;

export const Subtitle2 = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="subtitle2">{children}</Typography>;

export const P = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="body1">{children}</Typography>;

export const Body = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="body2">{children}</Typography>;

export const Caption = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="caption">{children}</Typography>;

export const Overline = ({
    children,
    ...props
}: CustomTypographyProps) => <Typography {...{ ...props, children }} variant="overline">{children}</Typography>;
